import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Analytics } from "@vercel/analytics/react";
import { Toaster } from "@/components/ui/sonner";
import { trackView } from "@/lib/track";
import LandingPage from "@/pages/LandingPage";
import AdminPage from "@/pages/AdminPage";
import PrivacyPage from "@/pages/PrivacyPage";

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    trackView(location.pathname);
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <RouteTracker />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
      </Routes>
      <Toaster position="top-center" richColors />
      <Analytics />
    </BrowserRouter>
  );
}

export default App;
